/*
 * Jira Ticket:
 * Created Date: Thu, 9th Apr 2020, 12:19:42 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getManyTowerTypeQuery = gql`
  query allTowerTypes(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: TowerTypeFilter
  ) {
    items: allTowerTypes(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      name
    }
    total: _allTowerTypesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;
